import { render, staticRenderFns } from "./SiteMisconceptions.vue?vue&type=template&id=819cc868&scoped=true"
var script = {}
import style0 from "./SiteMisconceptions.vue?vue&type=style&index=0&id=819cc868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819cc868",
  null
  
)

export default component.exports